import { kmm } from './kmm';

export async function extendRecording(sid: number, eventId: number): Promise<boolean> {
  return kmm((repo) => repo.extendEvent(sid, eventId), false);
}

export default extendRecording;
